<div
  class="read-status-marker"
  [class.read]="notification().read"
  tabindex="0"
  [uiTooltip]="'Mark as read'"
  (keypress.enter)="markAsRead($event)"
  (keypress.space)="markAsRead($event)"
  (click)="markAsRead($event)">
  <ui-svg-icon
    icon="none"
    [nuiIcon]="statusIcon()"
    size="xs" />
</div>
